'use client'

import { Button, Dialog, Spacer } from '@vinted/web-ui'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useLocation } from '@marketplace-web/shared/browser'

import { ProIntegrationsApplicationFormModel } from '../types'

const Footer = () => {
  const translate = useTranslate('business.pro_integrations_application.form.footer')
  const { formState } = useFormContext<ProIntegrationsApplicationFormModel>()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { goToPreviousPage: back } = useLocation()

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  return (
    <>
      <Dialog
        a11yCloseIconTitle="Close"
        body={translate('back_confirmation_modal.description')}
        show={isModalOpen}
        title={translate('back_confirmation_modal.title')}
        defaultCallback={closeModal}
        closeOnOverlay
        actions={[
          {
            text: translate('back_confirmation_modal.continue_action'),
            style: Button.Styling.Filled,
            callback: back,
          },
          {
            text: translate('back_confirmation_modal.cancel_action'),
            style: Button.Styling.Flat,
          },
        ]}
        testId="pro-integrations-application-back-modal"
      />
      <div className="u-hidden@portables u-flexbox u-justify-content-flex-end">
        <Button
          onClick={openModal}
          type={Button.Type.Button}
          inline
          text={translate('back_action')}
          testId="pro-integrations-application-back-button"
        />
        <Spacer size={Spacer.Size.Large} orientation={Spacer.Orientation.Vertical} />
        <Button
          type={Button.Type.Submit}
          styling={Button.Styling.Filled}
          inline
          text={translate('submit_action')}
          isLoading={formState.isSubmitting}
          testId="pro-integrations-application-submit-button"
          onClick={(event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            if (formState.isSubmitting) {
              event.preventDefault()
            }
          }}
        />
      </div>
      <div className="u-hidden@desktops">
        <Button
          type={Button.Type.Submit}
          styling={Button.Styling.Filled}
          text={translate('submit_action')}
          isLoading={formState.isSubmitting}
          testId="pro-integrations-application-submit-button-desktop"
          onClick={(event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            if (formState.isSubmitting) {
              event.preventDefault()
            }
          }}
        />
        <Spacer size={Spacer.Size.Large} orientation={Spacer.Orientation.Horizontal} />
        <Button
          onClick={openModal}
          type={Button.Type.Button}
          text={translate('back_action')}
          testId="pro-integrations-application-back-button-desktop"
        />
      </div>
    </>
  )
}

export default Footer
